import { TESTING_PLACE_ISUSE } from '../../constants/testing_place';
import './detail.css';

const TestingPlaceDetail = ({ item, onClose }) => {
  if (!item) return null;

  const place = item.placeObj || {};
  const testing = item.testingObj || {};

  const rows = [
    { label: '시험', value: testing.title || '-' },
    { label: '고사장명', value: item.name || place.name || '-' },
    { label: '지역본부', value: place.gcode || '-' },
    { label: '주소', value: [place.addressMain, place.addressDetail].filter(Boolean).join(' ') || '-' },
    { label: '전화번호', value: place.phone || '-' },
    { label: '고사장 안내', value: item.ment || '-' },
    { label: '고사실 수', value: item.rooms ?? '-' },
    { label: '수용인원', value: item.maxCount ?? '-' },
    { label: '주차안내', value: item.parking_info || item.parking || '-' },
    { label: '상태', value: TESTING_PLACE_ISUSE.name[item.isUse] || '-' },
  ];

  const mapUrl = item.map?.url ? `https://www.klata.or.kr${item.map.url}` : null;

  return (
    <div id="testing_place_detail">
      <div className="head">
        <h1>고사장 상세 정보</h1>
      </div>
      <div className="body">
        <table className="detail-table">
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <th>{row.label}</th>
                <td>{row.value}</td>
              </tr>
            ))}
            <tr>
              <th>약도</th>
              <td>
                {mapUrl
                  ? <img src={mapUrl} alt="약도" className="map-img" />
                  : '-'
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="foot">
        <button onClick={() => onClose()}>닫기</button>
      </div>
    </div>
  );
};

export default TestingPlaceDetail;
